const DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

function getDay(date) {
  return DAYS[new Date(date).getDay()];
}

function isSameCalendarDate(fromDate, toDate) {
  if (!fromDate || !toDate) return fromDate === toDate;

  const from = new Date(fromDate);
  const to = new Date(toDate);

  return (
    from.getFullYear() === to.getFullYear() &&
    from.getMonth() === to.getMonth() &&
    from.getDate() === to.getDate()
  );
}

function isSameCalendarMonth(fromDate, toDate) {
  if (!fromDate || !toDate) return fromDate === toDate;

  const from = new Date(fromDate);
  const to = new Date(toDate);

  return from.getFullYear() === to.getFullYear() && from.getMonth() === to.getMonth();
}

function displayDate(fromDate, toDate) {
  if (isSameCalendarDate(fromDate, toDate)) {
    return String(new Date(fromDate).getDate());
  }

  return `${new Date(fromDate).getDate()} - ${new Date(toDate).getDate()}`;
}

function displayMonth(fromDate, toDate) {
  const date = new Date(isSameCalendarDate(fromDate, toDate) ? fromDate : toDate);
  return date.toLocaleString('en-US', { month: 'short' });
}

function displayDateLine(fromDate, toDate) {
  const fromDay = new Date(fromDate).getDate();
  const toDay = new Date(toDate).getDate();
  const fromMonth = new Date(fromDate).toLocaleString('en-US', { month: 'short' });
  const toMonth = new Date(toDate).toLocaleString('en-US', { month: 'short' });

  if (isSameCalendarDate(fromDate, toDate)) {
    return `${fromDay} ${fromMonth}`;
  }

  if (isSameCalendarMonth(fromDate, toDate)) {
    return `${fromDay} - ${toDay} ${toMonth}`;
  }

  return `${fromDay} ${fromMonth} - ${toDay} ${toMonth}`;
}

function isCrossMonthRange(fromDate, toDate) {
  return !isSameCalendarDate(fromDate, toDate) && !isSameCalendarMonth(fromDate, toDate);
}

function formatDayTime(dayTime) {
  return dayTime.replace(/\n/g, ', ');
}

export {
  getDay,
  isSameCalendarDate,
  isSameCalendarMonth,
  displayDate,
  displayMonth,
  displayDateLine,
  isCrossMonthRange,
  formatDayTime,
};
